import { render } from "./BoardTopTemplate.vue?vue&type=template&id=2a69f61e&scoped=true"
import script from "./BoardTopTemplate.vue?vue&type=script&lang=js"
export * from "./BoardTopTemplate.vue?vue&type=script&lang=js"

import "./BoardTopTemplate.vue?vue&type=style&index=0&id=2a69f61e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a69f61e"

export default script